import { NovaObraProvider } from "./hooks/nova-obra.context";
import { useNovaObraScreen } from "./use-nova-obra";
import { NovaObraScreenView } from "./view-nova-obra";

/** Exportado só para os testes comporem o wizard com estado pré-carregado. */
export function NovaObraWizard() {
  const vm = useNovaObraScreen();

  return <NovaObraScreenView {...vm} />;
}

export function NovaObraScreen() {
  return (
    <NovaObraProvider>
      <NovaObraWizard />
    </NovaObraProvider>
  );
}

export type * from "./types-nova-obra";
